import React from "react";

const CircleBackground = () => {
  return (
    <svg
      id="ehckm9QTSPU1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 800 600"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
          style={{
      width: "100%",
      height: "100%",
      position:"absolute",
      top:"0px",
marginTop:"0px",
      overflow:"visible",
      display:"flex"

    }}
    >
      <defs>
        <filter
          id="ehckm9QTSPU3-filter"
          x="-150%"
          y="-150%"
          width="400%"
          height="400%"
        >
          <feGaussianBlur
            id="ehckm9QTSPU3-filter-blur-0"
            stdDeviation="75,75"
            result="result"
          />
        </filter>
      </defs>
      <g transform="translate(11 -88)" filter="url(#ehckm9QTSPU3-filter)">
        <circle
          r="234"
          transform="translate(380 384)"
          fill="#fcc"
          fillOpacity="0.2"
        />
      </g>
    </svg>
  );
};

export default CircleBackground;
